// @flow

export const states = {
    PLAYING: "playing",
    PAUSED: "paused",
    ENDED: "ended",
    SEEK: "seek",

};

export const STATS = {
    PLAYING: 1,
    PAUSED: 2,
    ENDED: 3,
    SEEK: 4
};

/**
 * Example: {'video/mp4': 'file.mp4', 'video/webm': 'file.webm'}
 */
export type VideoSources = {
    [string]: string
};

export default class TimelinelyPlayer {
    static players: { [string]: Function } = {};

    element: HTMLElement;
    controls: boolean;

    static addPlayer(source: any, klass: Function) {
        this.players[source] = klass;
    }

    static bySource(
        source: string,
        id: ?string,
        urls: ?VideoSources,
        element: HTMLElement,
        controls?: boolean
    ): TimelinelyPlayer {
        const playerClass = this.players[source];
        if (!playerClass)
            throw new Error(`Unable to find player for ${source}`);

        return new playerClass(id, urls, element, controls);
    }

    throwNotImplemented(methodName: string): void {
        throw new Error(
            `The method #${methodName} hasn't been implemented for ' + ${this.constructor.name}`
        );
    }

    constructor(
        id: ?string,
        urls: ?VideoSources,
        element: HTMLElement,
        controls?: boolean = false
    ) {
        this.element = element;
        this.controls = controls;
        this.init(id, urls);
    }

    init(id: ?string, urls: ?VideoSources): void {}

    // $FlowFixMe
    play(): Promise<void> {
        this.throwNotImplemented("play");
    }

    // $FlowFixMe
    pause(): Promise<void> {
        this.throwNotImplemented("pause");
    }

    // $FlowFixMe
    seekTo(seconds: number): Promise<void> {
        this.throwNotImplemented("seekTo");
    }

    // $FlowFixMe
    get duration(): Promise<number> {
        this.throwNotImplemented("getDuration");
    }

    // $FlowFixMe
    get currentTime(): Promise<number> {
        this.throwNotImplemented("getCurrentTime");
    }

    // $FlowFixMe
    get bufferedPercentage(): Promise<number> {
        this.throwNotImplemented("getBufferedPercentage");
    }

    // $FlowFixMe
    get volume(): Promise<number> {
        this.throwNotImplemented("play");
    }

    // $FlowFixMe
    set volume(value: any): Promise<void> {
        this.throwNotImplemented("setVolume");
    }

    // $FlowFixMe
    get state(): Promise<string> {
        this.throwNotImplemented("getState");
    }

    // $FlowFixMe
    get iframe(): Promise<HTMLIFrameElement> {
        this.throwNotImplemented("getIFrame");
    }

    onChangeState(callback: Function): void {
        this.throwNotImplemented("onChange");
    }

    /**
     * This method is called before the player is removed from the DOM.
     * The intention is to cleanup any resources that could case a memory leak,
     * for example attached event handlers
     */
    cleanup() {
        this.throwNotImplemented("cleanup");
    }
}



// WEBPACK FOOTER //
// ./src/timelinely-player/TimelinelyPlayer.js